export default __webpack_public_path__ + "static/media/footer-facebook.fc62a0db.svg";